import { useGetLatestQuestionQSetUsageReportUpdatedAtQuery } from '@report/graphql';
import { APP_PERMISSIONS } from '@report/permission';
import { QuestionUsageByQSetReportList } from '@report/question-usage-by-qset-report';
import { useNavigate } from '@report/router';
import { Flex, PageHeader, Text, Button, ArrowBackRoundedIcon, Box } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';
import { formatDateTime } from '@shared/utils';
export default function QuestionUsageByQSetReportPage() {
  const navigate = useNavigate();
  const { data } = useGetLatestQuestionQSetUsageReportUpdatedAtQuery();
  const latestUpdatedAt = formatDateTime(
    data?.reportGetLatestQuestionQSetUsageReportUpdatedAt.latestUpdatedAt,
  );

  return (
    <PermissionGuard requiredPermission={APP_PERMISSIONS.QUESTION_USAGE_BY_QSET_REPORT.VIEW}>
      <PageHeader
        title='รายงานการใช้งานข้อสอบแยกตามชุด'
        subtitleSection={
          <Flex sx={{ justifyContent: 'space-between', width: '100%' }}>
            <Text variant='body2' sx={{ color: (theme) => theme.palette.text.secondary }}>
              สรุปการใช้งานข้อสอบรายข้อ แยกตามชุดข้อสอบในหลักสูตร
            </Text>
            <Text variant='body2' sx={{ color: (theme) => theme.palette.text.secondary }}>
              อัปเดตข้อมูลล่าสุด: {latestUpdatedAt}
            </Text>
          </Flex>
        }
        linkAdornment={
          <Button
            variant='text'
            startIcon={<ArrowBackRoundedIcon />}
            onClick={() => navigate('/reports')}
            sx={{
              p: (theme) => theme.spacing(0),
              minWidth: 'auto',
              height: 'auto',
            }}
          >
            Back
          </Button>
        }
      />
      <Box sx={{ p: (theme) => theme.spacing(6) }}>
        <QuestionUsageByQSetReportList />
      </Box>
    </PermissionGuard>
  );
}
